import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import SiteSidebar from './SiteSidebar';
import { icon } from './ui';
import { portalHome } from './portalApi';
export default class TeamPage extends Page {
  data = null;
  loading = true;
  oninit(v) {
    super.oninit(v);
    portalHome().then(data => {
      this.data = data;
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  oncreate() {
    window.scrollTo(0, 0);
  }
  view() {
    const team = this.data?.team || [];
    const groups = team.reduce((acc, user) => {
      const key = user.team_name || 'Ekipa projektu';
      (acc[key] ||= []).push(user);
      return acc;
    }, {});
    return m("div", {
      className: "NtTeamPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", null, m("header", {
      className: "NtPageHeading"
    }, m("small", null, "LUDZIE TWORZ\u0104CY NOVATRUCK"), m("h1", null, "Ekipa projektu"), m("p", null, "Lista jest zarz\u0105dzana z Nova Control Center \u2192 Spo\u0142eczno\u015B\u0107 \u2192 Ekipa.")), this.loading ? m(LoadingIndicator, null) : Object.keys(groups).length ? m("div", {
      className: "NtTeamSections"
    }, Object.entries(groups).map(_ref => {
      let [name, members] = _ref;
      return m("section", {
        className: "NtTeamSection"
      }, m("h2", null, name), m("div", {
        className: "NtTeamMembers"
      }, members.map(user => m(Link, {
        href: `/u/${encodeURIComponent(user.username)}`,
        className: "NtTeamMember"
      }, m("span", {
        className: "NtTeamMemberAvatar"
      }, user.avatar_url ? m("img", {
        src: user.avatar_url,
        alt: ""
      }) : m("b", null, String(user.username).charAt(0).toUpperCase())), m("span", null, m("strong", {
        style: {
          color: user.color || '#e8eaec',
          '--role-color': user.color || '#e8eaec',
          '--role-background': user.background || 'transparent'
        },
        className: `NtNickEffect is-${user.effect || 'none'}`
      }, user.username), m("small", null, user.display_title || user.custom_title || user.role_name || 'Członek ekipy')), m("em", {
        className: user.online ? 'is-online' : ''
      }, user.online ? 'ONLINE' : 'offline')))));
    })) : m("div", {
      className: "NtPortalEmpty"
    }, "Lista ekipy jest pusta. Dodaj cz\u0142onk\xF3w w Nova Control Center."), m("section", {
      className: "NtTeamJoin"
    }, m("div", null, icon('fas fa-user-plus'), m("span", null, m("strong", null, "Chcesz do\u0142\u0105czy\u0107 do ekipy?"), m("small", null, "\u015Aled\u017A og\u0142oszenia rekrutacyjne na forum."))), m(Link, {
      className: "Button Button--primary",
      href: "/t/ogloszenia"
    }, "ZOBACZ OG\u0141OSZENIA")))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/TeamPage', TeamPage);